// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ReactToRactiveAdapter } from '../ReactToRactiveAdapter';
import { OrderInfoView } from './OrderInfoView';
export class OrderInfoViewRactive extends ReactToRactiveAdapter {
    constructor() {
        super();
    }
    attachEventHandlers(props) {
        props.onValueChanged = (value) => this.fire('valueChanged', this, value);
    }
}
ReactToRactiveAdapter.extendWith(OrderInfoViewRactive, {
    template: '<div class="order-info-view"></div>',
    mountContainer: '.order-info-view',
    reactComponent: OrderInfoView,
    data: function () {
        return {
            order: null,
            onValueChanged: null
        };
    }
});
